export const CONFIG = {

    views: ["week", "month", "agenda"],

    showAllDayPanel: true,
    allDayExpr: "allDay",
    allDay: true,
    allDayExpr: "long",
    dateSerializationFormat: "yyyy-MM-dd HH:mm:ss",
    height: 350,
    editing: {
        allowUpdating : true,
        allowAdding : true,
        allowDeleting : true
    }
}




